import * as React from 'react';
import { IShowcase } from '../../types/showcase/props';
import { ContentWrapper } from '../ContentWrapper';
import { Form } from '../Form';

import * as styles from './styles.css';

export const ShowcaseWall: React.FC<IShowcase> = ({
  formTitle,
  buttonTitle,
  error,
  loading,
  phone,
  submitPhone,
  setPhone,
  setOpen,
}) => {
  return (
    <div className={styles['wrapper']}>
      <ContentWrapper>
        <div className={styles['container']}>
          <div className={styles['content']}>
            <div className={styles['logo']} />
            <div className={styles['text']}>
              Получите одобрение от нескольких банков за&nbsp;2&nbsp;минуты.&nbsp;Это&nbsp;бесплатно
            </div>
          </div>
          <div className={styles['form']}>
            <Form
              formTitle={formTitle}
              buttonTitle={buttonTitle}
              error={error}
              loading={loading}
              phone={phone}
              submitPhone={submitPhone}
              setPhone={setPhone}
              setOpen={setOpen}
            />
          </div>
        </div>
      </ContentWrapper>
    </div>
  );
};
